import React, { useState } from "react";
import api from "../../../../Axios/api";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import {
  Avatar,
  Button,
  TextField,
  Paper,
  Grid,
  Typography,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { useUserContext, loginUser } from "../../../../context/UserContext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useStyles from "./styles";

const ForgetPassword = () => {
  const classes = useStyles();
  // context
  const { dispatch } = useUserContext();

  // Snackbar
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const initialValues = {
    email: "",
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please Enter a Valid Email")
      .required("Required"),
  });
  const onSubmit = (values, props) => {
    console.log(values);
    api
      .patch("/admin/forgetPassword", { values })
      .then((res) => console.log("Send Mail", res))
      .catch((error) => console.log("ERROR" + error));
  };
  return (
    <Grid container className={classes.root}>
      <Grid item xs={false} sm={4} md={7} className={classes.image}></Grid>
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOpenIcon />
          </Avatar>
          <Typography variant="h3">Forgot Your Password?</Typography>
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
          >
            {(props) => (
              <Form className={classes.form}>
                <Field
                  as={TextField}
                  name="email"
                  margin="normal"
                  label="Email Address"
                  name="email"
                  autoFocus
                  placeholder="Enter email"
                  fullWidth
                  required
                  helperText={<ErrorMessage name="email" />}
                />

                <Button
                  style={{ fontWeight: "bold", fontSize: 14 }}
                  type="submit"
                  color="primary"
                  variant="contained"
                  className={classes.submit}
                  fullWidth
                >
                  Reset Password
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </Grid>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
};

export default withRouter(ForgetPassword);

// import React, { useState } from "react";
// import AppBar from "@material-ui/core/AppBar";
// import Toolbar from "@material-ui/core/Toolbar";
// import Paper from "@material-ui/core/Paper";
// // import Link from "@material-ui/core/Link";
// import Typography from "@material-ui/core/Typography";
// import Grid from "@material-ui/core/Grid";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// // import Breadcrumbs from "@material-ui/core/Breadcrumbs";
// import Snackbar from "@material-ui/core/Snackbar";
// import IconButton from "@material-ui/core/IconButton";
// import CloseIcon from "@material-ui/icons/Close";

// import api from "../../../../Axios/api";
// import Logo from "../../../../assets/images/logo.png";

// import { withRouter } from "react-router-dom";
// import { useStyles } from "./styles";

// const ForgetPassword = () => {
//   const classes = useStyles();

//   const [userEmail, setuserEmail] = useState("");

//   const [state, setState] = useState({
//     open: false,
//     vertical: "top",
//     horizontal: "center",
//   });

//   const { vertical, horizontal, open } = state;

//   const handleClose = () => {
//     setState({ ...state, open: false });
//   };

//   const getPassword = () => {
//     api
//       .patch("/admin/forgetPassword", { email: userEmail })
//       .then((res) => console.log("Send Mail", res))
//       .catch((error) => console.log("ERROR" + error));

//     setState({ open: true, vertical: "bottom", horizontal: "center" });
//   };

//   return (
//     <React.Fragment>
//       <AppBar position="absolute" className={classes.appBar}>
//         <Toolbar>
//           <img src={Logo} alt="Logo" className={classes.logo} />
//         </Toolbar>
//       </AppBar>
//       <div
//         style={{
//           padding: "40px",
//           marginTop: "40px",
//           borderRadius: 20,
//           borderColor: "#000",
//           padding: 50,
//         }}
//       >
//         <main className={classes.layout}>
//           <Paper className={classes.paper} variant="outlined" square={true}>
//             <Typography variant="h4" className={classes.headingMargin}>
//               Forget Password
//             </Typography>
//             <Grid container spacing={3}>
//               <Grid item xs={12}>
//                 <TextField
//                   required
//                   name="userEmail"
//                   label="Your Email"
//                   fullWidth
//                   value={userEmail}
//                   onChange={(e) => setuserEmail(e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={12} className={classes.buttons}>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={getPassword}
//                 >
//                   Get Password
//                 </Button>
//                 <Snackbar
//                   anchorOrigin={{ vertical, horizontal }}
//                   open={open}
//                   onClose={handleClose}
//                   autoHideDuration={3000}
//                   message="Your password has been sent!"
//                   key={vertical + horizontal}
//                   action={[
//                     <IconButton
//                       key="close"
//                       color="inherit"
//                       onClick={handleClose}
//                     >
//                       <CloseIcon />
//                     </IconButton>,
//                   ]}
//                 />
//               </Grid>
//             </Grid>
//           </Paper>
//         </main>
//       </div>
//     </React.Fragment>
//   );
// };

// export default withRouter(ForgetPassword);
